<template>
  <div>صفحه سوالی دارید ؟</div>
</template>

<script>
export default {
  name: "Questions"
}
</script>

<style scoped>

</style>